<div class="container">
  <div class="content">
    <mat-icon svgIcon="unauthorized"></mat-icon>
    <h1 class="header-title">{{ 'GENERAL.ERRORS.STATUSCODE.UNAUTHORIZED.TITLE' | bmsTranslate }}!</h1>
  </div>
</div>
